// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7743520a","239":"dd904a78","361":"a51a7a3a","453":"fc11813f","455":"075854a9","762":"08243d7b"}[chunkId] + ".chunk.js";
};